unable to read source [project]/node_modules/stripe/src/StripeContext.ts